export enum LEAD_TYPE {
  CHAT_LEAD = 'chat_lead',
  CALL_LEAD = 'call_lead',
  SMARTFORM_LEAD = 'smartform_lead',
}
